import { LicenseStatus } from '@supply-mover-2-0/shared';

/**
 * License status options for create/edit dropdowns. "Expired" is omitted
 * because it's owned by the daily mark-expired job (see
 * apps/crm-api/.../mark-expired-licenses.handler.ts) — the job mirrors the
 * effective expiration date into status. Users renew a license by updating
 * the expiration date, and the job flips the status on the next run.
 */
export const LICENSE_STATUS_OPTIONS = Object.values(LicenseStatus)
	.filter((status) => status !== LicenseStatus.EXPIRED)
	.map((status) => ({
		value: status,
		label: status,
	}));

/**
 * Color mappings for license status badges.
 */
export const LICENSE_STATUS_COLORS: Record<string, string> = {
	[LicenseStatus.ACTIVE]: 'success',
	[LicenseStatus.PENDING]: 'warning',
	[LicenseStatus.EXPIRED]: 'error',
	[LicenseStatus.SUSPENDED]: 'error',
	[LicenseStatus.REVOKED]: 'error',
};

/**
 * Disciplinary action type options.
 */
export const DISCIPLINARY_ACTION_TYPE_OPTIONS = [
	{ value: 'Warning', label: 'Warning' },
	{ value: 'Fine', label: 'Fine' },
	{ value: 'Suspension', label: 'Suspension' },
	{ value: 'Revocation', label: 'Revocation' },
	{ value: 'Probation', label: 'Probation' },
	{ value: 'Letter of Reprimand', label: 'Letter of Reprimand' },
	{ value: 'Other', label: 'Other' },
];

/**
 * Disciplinary action severity options.
 */
export const DISCIPLINARY_SEVERITY_OPTIONS = [
	{ value: 'Critical', label: 'Critical' },
	{ value: 'High', label: 'High' },
	{ value: 'Medium', label: 'Medium' },
	{ value: 'Low', label: 'Low' },
];

/**
 * Disciplinary action status options.
 */
export const DISCIPLINARY_STATUS_OPTIONS = [
	{ value: 'Open', label: 'Open' },
	{ value: 'Resolved', label: 'Resolved' },
	{ value: 'Dismissed', label: 'Dismissed' },
];
